// extracted by mini-css-extract-plugin
export var notificationHost = "_k4-0";